import { render, staticRenderFns } from "./base-dialog.vue?vue&type=template&id=536cb80e&scoped=true&"
import script from "./base-dialog.vue?vue&type=script&lang=js&"
export * from "./base-dialog.vue?vue&type=script&lang=js&"
import style0 from "./base-dialog.vue?vue&type=style&index=0&id=536cb80e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "536cb80e",
  null
  
)

export default component.exports